import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { recovery } from "../../../services/authServices";

function RecoveryForm() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [orgId] = useState(
    process.env.NODE_ENV === "development" ? "162677420978" : "774776583851"
  );
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};

    if (!email) {
      newErrors.email = "This field is required.";
    } else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(email)) {
      newErrors.email = "Email is not valid.";
    } else if (email.length < 5) {
      newErrors.email = "Min 5 characters.";
    } else if (email.length > 100) {
      newErrors.email = "Max 100 characters.";
    }
    return newErrors;
  };

  const recover = async (e) => {
    if (e) e.preventDefault();
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }

    setErrors({});
    setLoading(true);

    const userdata = { email, orgId, isAdmin: false };

    try {
      const response = await recovery(userdata);
      setLoading(false);

      if (response.data.success) {
        toast.success("Recovery success! Check your email!");
        navigate("/recoveryc");
      } else {
        // console.log("response.data.error", response);
        toast.error(response.data.message || "Email not found!");
      }
    } catch (error) {
      setLoading(false);
      toast.error("Recovery failed! Please try again.");
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === "email") {
      setEmail(value);
    }
  };
  return (
    <div className="w-full lg:w-1/2 sm:p-3 sm:h-full sm:overflow-y-auto bg-black sm:pt-[12%] lg:pt-[13%] lg:pl-[4%] relative">
      <div className="sm:mr-0 lg:mr-[10%]">
        <div className="flex flex-col items-start sm:mb-2 lg:mb-4">
          <h2 className="sm:text-sm lg:text-2xl font-bold text-[#ffffff] mb-2 whitespace-nowrap">
            {" "}
            Password Recovery
          </h2>
        </div>

        <form onSubmit={recover} className="w-full">
          <div className="flex flex-col space-y-4">
            <div className="mb-4">
              <label
                htmlFor="email"
                className="w-[85px] h-8 font-montserrat not-italic font-normal text-[12px] leading-4 tracking-[-0.03em] text-gray-500 flex-none order-0 grow-0"
              >
                Email Address
              </label>
              <input
                id="email"
                name="email"
                type="email"
                value={email}
                onChange={handleChange}
                className={`w-full border ${
                  errors.email ? "border-red-500" : "border-gray-300"
                } rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-400 text-gray-700`}
                style={{ fontSize: "1rem" }}
                autoComplete="new-password"
              />
              {errors.email && (
                <p className="text-red-500 text-xs mt-1">{errors.email}</p>
              )}
            </div>

            <div className="mb-4">
              <button
                type="submit"
                className="sm:w-[100%] lg:w-[100%] bg-[#1CD760] rounded-full hover:bg-green-primary text-white font-semibold text-sm py-2 transition-colors duration-200 disabled:opacity-60 mt-2 flex items-center justify-center"
                disabled={loading}
              >
                {loading ? (
                  <span className="flex items-center justify-center">
                    <svg
                      className="animate-spin h-5 w-5 mr-2 text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8z"
                      ></path>
                    </svg>
                    Recovering...
                  </span>
                ) : (
                  "Recover Password"
                )}
              </button>
            </div>
          </div>
        </form>
        <div className="flex justify-between w-full text-sm mt-2">
          <a href="/login" className="text-lightblue-primary hover:underline">
            Back to Sign in
          </a>
          {/* <a href="/recoveryc" className="text-lightblue-primary hover:underline">Recover with code</a> */}
        </div>
      </div>
    </div>
  );
}

export default RecoveryForm;
